import { ClaudeTemplate } from "../types";

/** DV360 para display, vídeo, audio y CTV (deals de Netflix, Disney+, LG…). YouTube va aparte. */
export const dv360Template: ClaudeTemplate = {
  id: "dv360",
  tool: "Display & Video 360 (DV360)",
  url: "https://displayvideo.google.com/",
  hierarchy:
    "Partner → Advertiser → Campaign → Insertion Order (IO) → Line Item → Creatives asignadas",
  idHint:
    "columna ID de la tabla o número que aparece en la URL al abrir el IO (…/io/<ID>/…)",
  accountField: "dv360AdvertiserIds",
  steps: `
### 1. Entrar en el advertiser (puede que ya estés dentro)
1. Abre DV360 ({{url}}). Si ya está abierto, sigue.
2. Entra en el **Partner** de la agencia. Si solo hay uno o ya estás dentro, sigue.
3. Entra en el **Advertiser** del cliente {{client}}. ID(s) conocidos: {{accountIds}}. Si no hay ID, búscalo por el nombre del cliente; si hay varios candidatos, pregunta.

### 2. Campaign
1. En la pestaña Campaigns busca **{{names.campaign}}**. Si existe, entra y salta al paso 3.
2. Si no existe, créala ("New campaign"):
   - Name: {{names.campaign}}
   - Goal: el que mejor encaje con el objetivo {{goal.kpi}} (CPM/CPMV/CPV → "Raise awareness of my brand or product"; CPC/CPE → "Drive online action or visits"; CPA/CPL → "Drive online action or visits" con KPI de conversiones).
   - KPI: {{goal.kpi}} con valor {{goal.netUnitCost}}.
   - Planned dates: {{goal.startDate}} → {{goal.endDate}}.
   - Creative types: según el formato {{format}}.
   - Frequency cap: el que venga por defecto, salvo que las notas digan otra cosa.
3. Guarda.

### 3. Insertion Order
1. Dentro de la campaign, busca un IO llamado **{{names.order}}**. Si existe, no lo dupliques: entra, revisa los datos y salta al paso 4.
2. Si no existe, crea el IO ("New insertion order"):
   - Name: {{names.order}}
   - Budget: {{goal.budget}}, en importe (no impresiones), con un segmento de presupuesto {{goal.startDate}} → {{goal.endDate}}.
   - Pacing: "Flight", "Even".
   - Goal / KPI: {{goal.kpi}} = {{goal.netUnitCost}}.
   - Optimización automática de presupuesto: desactivada, salvo que las notas digan otra cosa.
   - Frequency cap: por defecto.
   - Estado: **Draft** (o Paused). No lo actives.
3. Guarda.

### 4. Line Item
1. Dentro del IO, crea un line item ("New line item"). El tipo depende del formato {{format}} y de las notas de esta línea: Display, Video, Audio u "Over-the-top" (CTV).
2. Configúralo:
   - Name: {{names.line}}
   - Flight dates: las del IO ({{goal.startDate}} → {{goal.endDate}}).
   - Budget: "Unlimited up to insertion order's budget", salvo que haya varias líneas en el IO y las notas indiquen un reparto.
   - Pacing: Even.
   - Bid strategy: si el objetivo es CPM, "Fixed bid" o "Target CPM" en torno a {{goal.netUnitCost}}; si es CPC, CPV o CPA, la estrategia automática equivalente con ese objetivo. Si no está claro, pregunta.
   - Inventory: exchanges por defecto del advertiser o el deal que digan las notas de la línea.
3. Targeting (añade solo lo que venga en el briefing):
   - Geography: {{target.geography}} (país {{goal.country}}).
   - Language: {{target.language}}.
   - Demographics: {{target.gender}}, {{target.age}}. Si el tipo de inventario no permite demografía, dímelo y sigue sin ella.
   - Devices / environment: {{target.technology}}.
   - Audience lists: {{target.audience}}. Intereses: {{target.interests}}. Si la audiencia no existe en el advertiser, no la crees: apúntalo.
   - Viewability: {{goal.visibility}} (si viene vacío, no lo toques).
   - Exclusiones: {{target.exclusions}}.
   - Brand safety: la configuración por defecto del advertiser.
4. Deja el line item en **Draft**. Guarda.

### 5. Creatives
1. Mira si las creatividades ya están en la biblioteca del advertiser (Creatives). Si están, asígnalas al line item.
2. Si no están, súbelas desde los enlaces del bloque "Creatividades". Si un enlace no abre o pide permisos, para y avísame.
3. URL de destino (landing) con su UTM: la del bloque "URLs de destino".
4. Comprueba que las creatividades quedan asignadas al line item {{names.line}}. Las creatividades pueden quedar pendientes de revisión de Google: es normal.
`,
};
